//reducer to handle the slides text
import { 
  FETCH_SLIDES_TEXT_REQUEST,
  FETCH_SLIDES_TEXT_SUCCESS,
  FETCH_SLIDES_TEXT_FAILURE
} from '../actions/SlidesTextActions';

const initialState = {
  slidesText: [],
  loading: false,
  error: null
};

const slidesTextReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SLIDES_TEXT_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_SLIDES_TEXT_SUCCESS:
      return { ...state, slidesText: action.payload, loading: false, error: null };
    case FETCH_SLIDES_TEXT_FAILURE:
      return { ...state, slidesText: [], loading: false, error: action.payload };
    default:
      return state;
  }
};

export default slidesTextReducer;

